define('views/modules/goal/story/goal-story-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',

    // templates
    'text!templates/modules/goal/story/goal-story-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TGoalStoryListItem
) {

    var VGoalStoryListItem = Backbone.View.extend({
        template: TGoalStoryListItem,
        className: "urowfix",

        initialize: function(opt) {
            opt = opt || {};
            this.goal = opt.goal;
        },
        render: function() {
            var model = this.model;
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                value: model.get(this.goal.getCalendarItemAttr()),
                date: model.getDate().format('D MMMM'),
                unit: this.goal.get('goalUnit')
            })));

            return this;
        },

    });

    return VGoalStoryListItem;

});

